import React, { useState } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import 'assets/css/suscription.css';

const BILLING_MONTHLY = 'monthly';
const BILLING_ANNUAL = 'annual';

const PLANS = [
    {
        id: 'free',
        nameKey: 'pricing_plan_free',
        blurbKey: 'pricing_plan_free_blurb',
        features: [
            'pricing_feature_storage_1y',
            'pricing_feature_core',
        ],
        prices: { monthly: 0, annual: 0 },
        ctaKey: 'pricing_cta_free',
        highlighted: false,
    },
    {
        id: 'plus',
        nameKey: 'pricing_plan_plus',
        blurbKey: 'pricing_plan_plus_blurb',
        features: [
            'pricing_feature_storage_unlimited',
            'pricing_feature_accounts_2',
            'pricing_feature_sync',
        ],
        prices: { monthly: 7.99, annual: 90 },
        ctaKey: 'pricing_cta_subscribe',
        highlighted: true,
    },
    {
        id: 'pro',
        nameKey: 'pricing_plan_pro',
        blurbKey: 'pricing_plan_pro_blurb',
        features: [
            'pricing_feature_storage_unlimited',
            'pricing_feature_accounts_5',
            'pricing_feature_sync',
            'pricing_feature_priority',
        ],
        prices: { monthly: 14.99, annual: 150 },
        ctaKey: 'pricing_cta_subscribe',
        highlighted: false,
    },
];

function formatMoney(value) {
    return Number(value).toFixed(2).replace(/\.00$/, '');
}

function Suscription() {
    const [billing, setBilling] = useState(BILLING_MONTHLY);
    const [selectedPlanId, setSelectedPlanId] = useState('plus');

    return (
        <div className="suscription-page">
            <div className="suscription-hero">
                <h1 className="suscription-title">
                    <Translate value="pricing_title" />
                </h1>
                <p className="suscription-subtitle">
                    <Translate value="pricing_subtitle" />
                </p>

                <div className="pricing-billing-toggle" role="tablist" aria-label={I18n.t('pricing_billing')}>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={billing === BILLING_MONTHLY}
                        className={`pricing-billing-btn${billing === BILLING_MONTHLY ? ' is-active' : ''}`}
                        onClick={() => setBilling(BILLING_MONTHLY)}
                    >
                        <Translate value="pricing_billing_monthly" />
                    </button>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={billing === BILLING_ANNUAL}
                        className={`pricing-billing-btn${billing === BILLING_ANNUAL ? ' is-active' : ''}`}
                        onClick={() => setBilling(BILLING_ANNUAL)}
                    >
                        <Translate value="pricing_billing_annual" />
                        <span className="pricing-billing-save">
                            <Translate value="pricing_billing_save" />
                        </span>
                    </button>
                </div>
            </div>

            <div className="pricing-grid">
                {PLANS.map((plan) => {
                    const price = plan.prices[billing];
                    const isSelected = selectedPlanId === plan.id;
                    const periodKey = billing === BILLING_ANNUAL
                        ? 'pricing_per_year'
                        : 'pricing_per_month';

                    return (
                        <article
                            key={plan.id}
                            className={[
                                'pricing-card',
                                plan.highlighted ? 'pricing-card--featured' : '',
                                isSelected ? 'is-selected' : '',
                            ].filter(Boolean).join(' ')}
                        >
                            {plan.highlighted && (
                                <span className="pricing-card-badge">
                                    <Translate value="pricing_popular" />
                                </span>
                            )}
                            <h2 className="pricing-card-name">
                                <Translate value={plan.nameKey} />
                            </h2>
                            <p className="pricing-card-blurb">
                                <Translate value={plan.blurbKey} />
                            </p>

                            <div className="pricing-card-price">
                                {price === 0 ? (
                                    <span className="pricing-card-amount">
                                        <Translate value="pricing_free_price" />
                                    </span>
                                ) : (
                                    <>
                                        <span className="pricing-card-currency">$</span>
                                        <span className="pricing-card-amount">{formatMoney(price)}</span>
                                        <span className="pricing-card-period">
                                            <Translate value={periodKey} />
                                        </span>
                                    </>
                                )}
                            </div>

                            <ul className="pricing-card-features">
                                {plan.features.map((featureKey) => (
                                    <li key={featureKey}>
                                        <Translate value={featureKey} />
                                    </li>
                                ))}
                            </ul>

                            <button
                                type="button"
                                className={`btn ${plan.id === 'free' ? 'btn-secondary' : 'btn-primary'} pricing-card-cta`}
                                onClick={() => setSelectedPlanId(plan.id)}
                            >
                                <Translate value={isSelected ? 'pricing_cta_selected' : plan.ctaKey} />
                            </button>
                        </article>
                    );
                })}
            </div>
        </div>
    );
}

export default Suscription;
